export default __webpack_public_path__ + "static/media/services-top-icon.65ad0f26.png";